import { render, staticRenderFns } from "./NonPartnerBadge.vue?vue&type=template&id=9b3a19ea&scoped=true&"
import script from "./NonPartnerBadge.vue?vue&type=script&lang=js&"
export * from "./NonPartnerBadge.vue?vue&type=script&lang=js&"
import style0 from "./NonPartnerBadge.vue?vue&type=style&index=0&id=9b3a19ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3a19ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
